import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Button, Table, Form, Input, Select } from 'antd';
import { actions, asyncUpdate, asyncGet } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;

class Edit extends React.Component {
    handleCancel = () => {
        this.props.changeCurrentSelect({});
        this.props.modalHide();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                const {
                    item: { record },
                } = this.props;
                console.log(record);
                const formData = formatFormData(values);
                await this.props.asyncUpdate({ ...record, ...formData });
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.asyncGet();
            }
        });
    };
    render() {
        const { isModalShow, isLoading, item } = this.props;
        const { record = {}, type } = item;
        const { taskList = [], resolve = '' } = record;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="状态">
                            {getFieldDecorator('type', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择状态',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    <Option value="1">有异常</Option>

                                    <Option value="2">正常</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="备注">
                            {getFieldDecorator('resolve')(<Input placeholder="请填写备注" style={{ width: '100%' }} />)}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
        const columns = [
            {
                title: '任务类型',
                dataIndex: 'taskSource',
                key: 'taskSource',
            },
            {
                title: '名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: 'eId',
                dataIndex: 'eId',
                key: 'eId',
            },
            {
                title: 'ps',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: '总量控制',
                dataIndex: 'tc',
                key: 'tc',
            },
            {
                title: '类型',
                dataIndex: 'taskType',
                key: 'taskType',
            },
            {
                title: 'est',
                dataIndex: 'est',
                key: 'est',
            },
            {
                title: 'act',
                dataIndex: 'act',
                key: 'act',
            },
            {
                title: 'est2',
                dataIndex: 'est2',
                key: 'est2',
            },
            {
                title: 'act2',
                dataIndex: 'act2',
                key: 'act2',
            },
            {
                title: '期望率',
                dataIndex: 'hopeRate',
                key: 'hopeRate',
            },
            {
                title: '完成率',
                dataIndex: 'finishedRate',
                key: 'finishedRate',
            },
            {
                title: '停留时长(S)',
                dataIndex: 'averageStayTime',
                key: 'averageStayTime',
                render: (text, record) => {
                    if (text) {
                        return <span>{(text / 1000).toFixed(2)}</span>;
                    } else {
                        return <span>0</span>;
                    }
                },
            },
            {
                title: '跳出率',
                dataIndex: 'tiaochuRatio',
                key: 'tiaochuRatio',
                render: (text, record) => {
                    if (text) {
                        return <span>{text.toFixed(2)}</span>;
                    } else {
                        return <span>0</span>;
                    }
                },
            },
            {
                title: '到达率',
                dataIndex: 'arriveRatio',
                key: 'arriveRatio',
                render: (text, record) => {
                    if (text) {
                        return <span>{text.toFixed(2)}</span>;
                    } else {
                        return <span>0</span>;
                    }
                },
            },
        ];
        return (
            <span>
                <Modal
                    width={1000}
                    title={type ? '签到' : '查看'}
                    visible={isModalShow}
                    footer={null}
                    confirmLoading={isLoading}
                    onCancel={this.handleCancel}>
                    <Spin spinning={isLoading} tip="保存中...">
                        <Table
                            style={{ marginBottom: '10px' }}
                            columns={columns}
                            dataSource={taskList}
                            pagination={false}
                        />
                        {type ? (
                            <div>
                                {form}
                                <Row>
                                    <Col
                                        span={24}
                                        style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                                        <Button type="primary" style={{ margin: '0 8px' }} onClick={this.handleOk}>
                                            确定
                                        </Button>
                                        <Button onClick={this.handleCancel} style={{ margin: '0 8px' }}>
                                            取消
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        ) : (
                            <div>备注：{resolve}</div>
                        )}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.signList.currentSelect,
    isModalShow: state.signList.uiStatus.isUpdateShow,
    isLoading: state.signList.uiStatus.isLoading,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncGet: () => dispatch(asyncGet()),
    changeCurrentSelect: data => dispatch(actions.changeCurrentSelect(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/sign/signList/edit.js